import { combineReducers } from "@reduxjs/toolkit";
import AUTH from "./Auth";
import GENERAL from "./GENERAL";
import ADMIN from "./Admin";
import USER from "./User";
import SESSION from "./Session";
import CentersSystem from "./Admin/centerSlice";
const combineReducer = combineReducers({
  [AUTH.slice.name]: AUTH.slice.reducer,
  [USER.slice.name]: USER.slice.reducer,
  [SESSION.slice.name]: SESSION.slice.reducer,
  [GENERAL.slice.name]: GENERAL.slice.reducer,
  [ADMIN.slice.name]: ADMIN.slice.reducer,
  [CentersSystem.centersSlice.name]: CentersSystem.centersSlice.reducer,
});

export default combineReducer;
